export enum AppointmentRatingScreen {
  LOADING,
  ERROR,
  ALREADY_RATED,
  RATE_NOW,
  EXPIRED
}
